/**
 * AdminResellersRpcClient - AtomRpc integration for admin reseller endpoints
 *
 * Requires admin authentication via Clerk session token.
 *
 * @since 1.0.0
 */
import { AtomRpc } from "@effect-atom/atom-react";
import { FetchHttpClient } from "@effect/platform";
import { RpcSerialization } from "@effect/rpc";
import { AdminResellersRpcs } from "@fm/api/rpc";
import { Layer } from "effect";
import { makeRpcClientLayer, makeTokenGetterLayer } from "./shared.ts";

export class AdminResellersRpcClient extends AtomRpc.Tag<AdminResellersRpcClient>()(
  "AdminResellersRpcClient",
  {
    group: AdminResellersRpcs,
    protocol: makeRpcClientLayer(AdminResellersRpcs).pipe(
      Layer.provide(RpcSerialization.layerNdjson),
      Layer.provide(makeTokenGetterLayer()),
      Layer.provide(FetchHttpClient.layer),
    ),
  },
) {}
